import { HAPTIC_VIBRATION_MS } from '../constants/ui';

/**
 * Fires a short vibration via the Web Vibration API when supported.
 *
 * Android Chrome supports `navigator.vibrate(...)` and produces a real
 * device buzz. iOS Safari does not implement the Vibration API, so the
 * call silently no-ops there — iOS users get the visual shake animation
 * instead. This is an accepted platform limitation: iOS Safari has no
 * usable async-firing haptic API (the gesture-bound `<input switch>`
 * trick cannot survive an `await` boundary).
 */
export const triggerHapticFeedback = (): void => {
  if ('vibrate' in navigator) {
    navigator.vibrate?.(HAPTIC_VIBRATION_MS);
  }
};
